<template>
  <div>
    <a-modal v-model:visible="visible" :title="'关联门店 - ' + (record.name || '')" @ok="visible = false" okText="完成"
      cancelText="取消" :afterClose="closeModal" :cancelButtonProps="{ style: { display: 'none' } }" width="55vw">
      <a-spin :spinning="loading">
        <div class="clubCheckbox">
          <a-checkbox v-for="club in clubs" :key="club.id" :checked="!!relationMap[club.id]" :disabled="loading"
            @change="onChange($event, club)">{{ club.name }}</a-checkbox>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
// 菜单 → 门店 反向关联弹窗：
// 后端 sys/club/menu/list 只支持按 clubId 查某门店的菜单树（子菜单带 relationId 表示已关联），
// 不支持按 menuId 反查门店，因此这里拉门店列表后并发逐店查询当前菜单的关联状态。
import { Search as SearchClub } from "/src/api/club.js";
import { Search as SearchClubMenu, Add, Delete } from "/src/api/clubMenu.js";

// 门店范围与「门店菜单管理」页（src/views/club/search.vue）保持一致：
// 该页 pageSize=12，接口一次性返回全部门店、由 a-table 前端分页，页面上一屏显示的就是前 12 家，
// 所以这里同样只取这 12 家。
const CLUB_PAGE_SIZE = 12;

export default {
  components: {},
  data() {
    return {
      visible: this.modelValue,
      loading: false,
      clubs: [],
      relationMap: {}, // clubId -> relationId（null 表示未关联）
    };
  },
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: () => ({}),
    },
    // 当前菜单所属客户端（菜单管理页顶部下拉选中的值）
    clientAppName: {
      type: String,
      default: "智慧中医",
    },
  },
  methods: {
    // 查询单个门店与当前菜单的关联，返回 relationId（未关联返回 null）
    async fetchRelation(clubId) {
      const res = await SearchClubMenu({ clubId, type: "菜单", clientAppName: this.clientAppName });
      if (res.errCode == 0) {
        for (const root of res.data || []) {
          const hit = (root.subMenus || []).find(item => item.id === this.record.id);
          if (hit && hit.relationId) return hit.relationId;
        }
      }
      return null;
    },
    async detail() {
      if (!this.record.id) return;
      this.loading = true;
      try {
        // 1. 拉门店列表：与「门店菜单管理」页同一接口、同一分页口径，
        //    后端返回的是全量数组，这里截取页面第一页显示的 12 家门店
        let clubs = [];
        const res = await SearchClub({ pageSize: CLUB_PAGE_SIZE, current: 1 });
        if (res.errCode == 0) {
          clubs = (res.data || []).slice(0, CLUB_PAGE_SIZE);
        } else {
          this.$message.error("门店列表查询失败", function () { });
        }
        this.clubs = clubs;
        // 2. 并发查询每家门店与当前菜单的关联状态
        const relations = await Promise.all(clubs.map(club => this.fetchRelation(club.id)));
        const map = {};
        clubs.forEach((club, i) => {
          map[club.id] = relations[i];
        });
        this.relationMap = map;
      } finally {
        this.loading = false;
      }
    },
    async onChange(e, club) {
      if (e.target.checked) {
        const res = await Add({ clubId: club.id, menuId: this.record.id, menuName: this.record.name });
        if (res.errCode != 0) {
          this.$message.error("关联失败", function () { });
          return;
        }
      } else {
        const relationId = this.relationMap[club.id];
        if (!relationId) return;
        const res = await Delete({ id: relationId });
        if (res.errCode != 0) {
          this.$message.error("取消关联失败", function () { });
          return;
        }
      }
      // 只刷新这一家店的关联状态，拿到最新的 relationId（下次取消勾选要用）
      const relationId = await this.fetchRelation(club.id);
      this.relationMap = { ...this.relationMap, [club.id]: relationId };
    },
    closeModal() {
      this.$emit("update:modelValue", false);
    },
  },
  watch: {
    modelValue(val) {
      this.visible = val;
      if (val) {
        this.detail();
      }
    },
  },
};
</script>

<style scoped>
.clubCheckbox {
  display: flex;
  flex-wrap: wrap;
}

.clubCheckbox label {
  width: 25%;
  margin: 10px 0;
}
</style>
